// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    /* max-height: calc(100vh - 365px); */
    overflow: auto;
}

.container{
    /* overflow: auto; */
    height:200px;
    margin-bottom: 15px;
    overflow:auto;

}

table {
    overflow: auto;
    border-collapse: collapse;
    width: 100%;
}

.table-spec {
    width: 100%;
    max-width: 100%;
    empty-cells: show;
    border: 0;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    font-weight: normal;
}

td {
    padding: 6px 10px;
}

th {
    border-top: none;
    position: sticky;
    top: 0;
    padding: 10px;
    background: #212529;
    color: #ffffff;
    font-size: 14px;
    z-index: 1;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}

.first td:nth-child(1) {
    color: teal;
}

.alignIt{
    margin-right: 5px;
    float: right;
    /* padding-bottom: 1px; */
}

.labelStyle{
    font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; 
    font-size: 14px;
}

span[aria-label-action]:hover:after {
    content: attr(aria-label-action);
    padding: 4px 8px;
    position: absolute;
    right: 30px;
    top: -10px;
    white-space: nowrap;
    z-index: 999999;
    background:teal;
    color: white;
    border-radius: 5px;
    font-size: 16px;
  }

  .wwidRole{
      font-size: 20px;
      padding: 10px;
      background-color: #000;
      color: #ffffff;
  }

  .tableColumnFilter {
    background-color: white;
    border-radius: 4px;
    width: 100%;
    height: 31px;
    color:black;
    padding-left: 15px;
    border: 2px hidden black;
  }
  
  .app-toolbar{
    border:1px solid grey;
    position: sticky;
    position: -webkit-sticky; 
    top: 0;
    z-index: 1000;
  }

  .form-control{
    height: 25px;
    line-height: 0.6 !important;
  }

  .first td:nth-child(1) {
    color: teal;
}

.active {
    background-color: teal !important;
    color: white;
}

.active td:nth-child(1) {
    color: white;
}

.child {
    background-color: white !important;
    border-left: 4px solid teal;
    border-right: 3px solid teal;
    border-bottom: 2px solid teal;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/dbu-tools/wwid-access/wwid-access.component.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mFAAmF;IACnF,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;MACI,eAAe;MACf,aAAa;MACb,sBAAsB;MACtB,cAAc;EAClB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,MAAM;IACN,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,WAAW;AACf;;AAEA;IACI,iCAAiC;IACjC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA,ogKAAogK","sourcesContent":[".table-container {\r\n    /* max-height: calc(100vh - 365px); */\r\n    overflow: auto;\r\n}\r\n\r\n.container{\r\n    /* overflow: auto; */\r\n    height:200px;\r\n    margin-bottom: 15px;\r\n    overflow:auto;\r\n\r\n}\r\n\r\ntable {\r\n    overflow: auto;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.table-spec {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    empty-cells: show;\r\n    border: 0;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n\r\ntd {\r\n    padding: 6px 10px;\r\n}\r\n\r\nth {\r\n    border-top: none;\r\n    position: sticky;\r\n    top: 0;\r\n    padding: 10px;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    z-index: 1;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}\r\n\r\n.first td:nth-child(1) {\r\n    color: teal;\r\n}\r\n\r\n.alignIt{\r\n    margin-right: 5px;\r\n    float: right;\r\n    /* padding-bottom: 1px; */\r\n}\r\n\r\n.labelStyle{\r\n    font-family: ProximaNova-Regular, TeXGyreHerosRegular, Helvetica, Arial, sans-serif; \r\n    font-size: 14px;\r\n}\r\n\r\nspan[aria-label-action]:hover:after {\r\n    content: attr(aria-label-action);\r\n    padding: 4px 8px;\r\n    position: absolute;\r\n    right: 30px;\r\n    top: -10px;\r\n    white-space: nowrap;\r\n    z-index: 999999;\r\n    background:teal;\r\n    color: white;\r\n    border-radius: 5px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  .wwidRole{\r\n      font-size: 20px;\r\n      padding: 10px;\r\n      background-color: #000;\r\n      color: #ffffff;\r\n  }\r\n\r\n  .tableColumnFilter {\r\n    background-color: white;\r\n    border-radius: 4px;\r\n    width: 100%;\r\n    height: 31px;\r\n    color:black;\r\n    padding-left: 15px;\r\n    border: 2px hidden black;\r\n  }\r\n  \r\n  .app-toolbar{\r\n    border:1px solid grey;\r\n    position: sticky;\r\n    position: -webkit-sticky; \r\n    top: 0;\r\n    z-index: 1000;\r\n  }\r\n\r\n  .form-control{\r\n    height: 25px;\r\n    line-height: 0.6 !important;\r\n  }\r\n\r\n  .first td:nth-child(1) {\r\n    color: teal;\r\n}\r\n\r\n.active {\r\n    background-color: teal !important;\r\n    color: white;\r\n}\r\n\r\n.active td:nth-child(1) {\r\n    color: white;\r\n}\r\n\r\n.child {\r\n    background-color: white !important;\r\n    border-left: 4px solid teal;\r\n    border-right: 3px solid teal;\r\n    border-bottom: 2px solid teal;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
